export default {"id":"4c1de8a8","attrs":{"viewBox":"0 0 16 16","width":"16","height":"16"}}